import React from 'react';

const useUniversalLayoutEffect =
    typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
export default useUniversalLayoutEffect;
